import { Link } from '@remix-run/react'

export const AppHeader = () => {
	return (
		<nav className="mx-auto flex max-w-7xl items-center justify-between p-6 lg:px-8">
			<Link to="/">
				<img src="/img/logo.png" alt="EB100 Logo" className="w-12" />
			</Link>
		</nav>
	)
}
